var map = {
	"./ca.json": 50672,
	"./de.json": 52912,
	"./en.json": 31835,
	"./es.json": 77180,
	"./eu.json": 9568,
	"./fr.json": 96952,
	"./it.json": 97388,
	"./pt.json": 87512,
	"./tr.json": 97608
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2812;